import React from "react";

const TspConferenceProgram = () => {
  return (
    <div className="container" style={{ marginTop: "100px" }}>
      <div
        className="text-center py-4"
        style={{
          background: "#195f7d",
          color: "#fff",
          border: "1px solid #000",
        }}
      >
        <h4 className="fw-bold mb-2">
          28<sup>th</sup> Annual Conference
        </h4>
        <h3 className="fw-bold mb-2">
          Association of Medical Physicists of India
        </h3>
        <h4 className="fw-bold mb-2">(Tamil Nadu and Puducherry Chapter)</h4>
        <h2 className="fw-bold mb-3">TNPY AMPICON 2025</h2>
        <h5 className="fw-bold mb-0">
          26<sup>th</sup> - 27<sup>th</sup> September 2025, M Conventions,
          Vanagaram, Chennai, TN.
        </h5>
      </div>
      <div
        className="text-center py-3 d-flex justify-content-center align-items-center flex-wrap"
        style={{
          background: "#f3c8a5",
          color: "#222",
          border: "1px solid #000",
          borderTop: "none",
        }}
      >
        <h2 className="fw-bold mb-0 me-3" style={{ display: "inline-block" }}>
          SCIENTIFIC PROGRAM
        </h2>
        <a
          href="/ScientificProgram.pdf"
          download
          className="btn btn-primary"
          style={{
            background: "#195f7d",
            border: "none",
            fontWeight: 500,
            fontSize: "1rem",
            padding: "8px 18px",
          }}
        >
          Download PDF
        </a>
      </div>
      <div className="row m-0 mt-3">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0">
            <div
              className="card-body text-center"
              style={{ background: "#e9f5fa", color: "#195f7d" }}
            >
              <h4 className="fw-bold mb-0">26.09.2025 - DAY 1 (FRIDAY)</h4>
            </div>
          </div>
        </div>
      </div>
      {/* --- Responsive Program Rows --- */}
      <div className="row m-0 ">
        <div className="col-12 p-0">{/* Day 1 Card */}</div>
      </div>
      {/* Day 1 Sessions - Unified for desktop and mobile */}
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mb-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              DAY 1 SESSIONS
            </div>

            <div className="card-body p-0">
              {/* Table Header Row for desktop */}
              <div
                className="row align-items-center border-bottom m-0 d-none d-md-flex"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  Venue
                </div>
              </div>
              {/* Data Rows for desktop */}
              {[
                {
                  time: "08:00 – 12:30",
                  session:
                    "PRE-CONFERENCE WORKSHOP ON HYBRID PLANNING STRATEGIES FOR BREAST CANCER (ECLIPSE & MONACO TPS)",
                  venue: "APOLLO CANCER CENTRE, VANAGARAM",
                },
                {
                  time: "12:30 – 13:30",
                  session: "CONFERENCE REGISTRATION / LUNCH BREAK",
                  venue: "M CONVENTIONS, VANAGARAM, CHENNAI",
                },
                {
                  time: "13:30 – 13:45",
                  session: "WELCOME & INTRODUCTION",
                  venue: "M CONVENTIONS, VANAGARAM, CHENNAI",
                },
              ].map((row, idx) => (
                <div
                  className="row align-items-center m-0 d-none d-md-flex border-bottom m-0"
                  key={idx}
                >
                  <div
                    className="col-2 text-center fw-bold py-3"
                    style={{ color: "#195f7d" }}
                  >
                    {row.time}
                  </div>
                  <div
                    className="col-6 py-3"
                    style={{ color: "#222", fontWeight: 500 }}
                  >
                    {row.session}
                  </div>
                  <div
                    className="col-4 py-3"
                    style={{ color: "#222", fontWeight: 500 }}
                  >
                    {row.venue}
                  </div>
                </div>
              ))}
              {/* Mobile view: stacked headers and cards */}
              <div className="d-block d-md-none">
                <div className="px-3 py-2">
                  <div
                    className="fw-bold"
                    style={{ color: "#195f7d", fontSize: "0.98rem" }}
                  >
                    Time
                  </div>
                  <div
                    className="fw-bold"
                    style={{ color: "#195f7d", fontSize: "0.98rem" }}
                  >
                    Session
                  </div>
                  <div
                    className="fw-bold"
                    style={{ color: "#195f7d", fontSize: "0.98rem" }}
                  >
                    Venue
                  </div>
                </div>
                {[
                  {
                    time: "08:00 – 12:30",
                    session:
                      "PRE-CONFERENCE WORKSHOP ON HYBRID PLANNING STRATEGIES FOR BREAST CANCER (ECLIPSE & MONACO TPS)",
                    venue: "APOLLO CANCER CENTRE, VANAGARAM",
                  },
                  {
                    time: "12:30 – 13:30",
                    session: "CONFERENCE REGISTRATION / LUNCH BREAK",
                    venue: "M CONVENTIONS, VANAGARAM, CHENNAI",
                  },
                  {
                    time: "13:30 – 13:45",
                    session: "WELCOME & INTRODUCTION",
                    venue: "",
                  },
                ].map((row, idx) => (
                  <div
                    className="card mb-2"
                    key={idx}
                    style={{
                      border: "none",
                      boxShadow: "0 1px 4px rgba(25,95,125,0.06)",
                    }}
                  >
                    <div className="card-body p-2">
                      <div
                        className="fw-bold mb-1"
                        style={{ color: "#195f7d", fontSize: "0.95rem" }}
                      >
                        {row.time}
                      </div>
                      <div
                        className="mb-1"
                        style={{
                          color: "#222",
                          fontSize: "0.95rem",
                          fontWeight: 500,
                        }}
                      >
                        {row.session}
                      </div>
                      <div style={{ color: "#195f7d", fontSize: "0.92rem" }}>
                        {row.venue}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* DAY 1 SESSIONS - Responsive headers and cards for mobile */}
      <div className="d-block d-md-none">
        <div className="card border-dark rounded-0 mb-3">
          <div
            className="card-header text-center fw-bold"
            style={{ background: "#195f7d", color: "#fff", fontSize: "1rem" }}
          >
            DAY 1 SESSIONS
          </div>
          <div className="card-body p-0">
            <div className="px-3 py-2">
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Time
              </div>
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Session
              </div>
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Venue
              </div>
            </div>
            {[
              {
                time: "08:00 – 12:30",
                session:
                  "PRE-CONFERENCE WORKSHOP ON HYBRID PLANNING STRATEGIES FOR BREAST CANCER (ECLIPSE & MONACO TPS)",
                venue: "APOLLO CANCER CENTRE, VANAGARAM",
              },
              {
                time: "12:30 – 13:30",
                session: "CONFERENCE REGISTRATION / LUNCH BREAK",
                venue: "M CONVENTIONS, VANAGARAM, CHENNAI",
              },
              {
                time: "13:30 – 13:45",
                session: "WELCOME & INTRODUCTION",
                venue: "",
              },
            ].map((row, idx) => (
              <div
                className="card mb-2"
                key={idx}
                style={{
                  border: "none",
                  boxShadow: "0 1px 4px rgba(25,95,125,0.06)",
                }}
              >
                <div className="card-body p-2">
                  <div
                    className="fw-bold mb-1"
                    style={{ color: "#195f7d", fontSize: "0.95rem" }}
                  >
                    {row.time}
                  </div>
                  <div
                    className="mb-1"
                    style={{
                      color: "#222",
                      fontSize: "0.95rem",
                      fontWeight: 500,
                    }}
                  >
                    {row.session}
                  </div>
                  <div style={{ color: "#195f7d", fontSize: "0.92rem" }}>
                    {row.venue}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Desktop view for DAY 1 SESSIONS remains unchanged */}
      {/* ORATION SESSIONS - Responsive rows for mobile */}
      <div className="d-block d-md-none">
        <div className="card border-dark rounded-0 mb-3">
          <div className="card-body p-0">
            <div className="px-3 py-2">
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Time
              </div>
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Session
              </div>
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Speaker / Moderator / Chairperson
              </div>
            </div>
            {[
              {
                time: "13:45 – 14:30",
                session:
                  "ORATION I\nPROF. C. RETHINASABAPATHY ENDOWMENT ORATION",
                speaker:
                  "CHAIRPERSONS\nDR N VIJAYAPRABU, CHAIRMAN, TNPY AMPI\nDR G BHARANIDHARAN, SECRETARY, TNPY AMPI\nDR S SURESH S, HEAD - MEDICAL ONCOLOGY, APOLLO HOSPITALS, VANAGARAM",
              },
              {
                time: "",
                session:
                  "EVOLUTION OF RADIOTHERAPY TECHNIQUES IN THE MANAGEMENT\nOF MALIGNANT DISEASE",
                speaker:
                  "DR K MUTHUVELU, PROFESSOR OF RADIOLOGICAL PHYSICS, SRMMCH&RC,\nKATTANGULATHUR",
              },
              {
                time: "14:30 – 15:15",
                session:
                  "PD 01: PANEL DISCUSSION\n(TEAM RADIATION ONCOLOGIST AND MEDICAL PHYSICIST)",
                speaker:
                  "MODERATOR\nMR M MARIYAPPAN, MEDICAL PHYSICIST, APOLLO HOSPITALS, TEYNAMPET",
              },
              {
                time: "",
                session:
                  "STEREOTACTIC RADIOSURGERY AND RADIOTHERAPY –\n2K PRACTICES DEPLOYING TECHNICAL INNOVATIONS",
                speaker:
                  "PANELIST\nDR S SHAMSUDEEN, RADIATION ONCOLOGIST, APOLLO HOSPITALS, TEYNAMPET\nMR S ANTO VAZ, MEDICAL PHYSICIST, KOVAI MEDICAL CENTRE AND HOSPITAL, COIMBATORE\nDR PONNUSAMY, MEDICAL PHYSICIST , NIMHANS, BANGALORE\nMR SAJI OOMMEN, MEDICALPHYSICIST, APOLLO HOSPITALS, DELHI\nDR S VENDHAN, MEDICAL PHYSICIST, APOLLO HOSPITALS, TEYNAMPET",
              },
              {
                time: "15:15 – 15:30",
                session: "TEA BREAK",
                speaker: "",
              },
            ].map((row, idx) => (
              <div
                className="card mb-2"
                key={idx}
                style={{
                  border: "none",
                  boxShadow: "0 1px 4px rgba(25,95,125,0.06)",
                }}
              >
                <div className="card-body p-2">
                  <div
                    className="fw-bold mb-1"
                    style={{ color: "#195f7d", fontSize: "0.95rem" }}
                  >
                    {row.time}
                  </div>
                  <div
                    className="mb-1"
                    style={{
                      color: "#222",
                      fontSize: "0.95rem",
                      fontWeight: 500,
                    }}
                  >
                    {row.session}
                  </div>
                  {row.speaker && (
                    <div style={{ color: "#195f7d", fontSize: "0.92rem" }}>
                      {row.speaker}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Desktop view for ORATION SESSIONS remains unchanged */}
      <div className="row m-0 d-none d-md-flex">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0">
            <div className="card-body p-0">
              {/* Table Header Row */}
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* Row 1 */}
              <div className="row align-items-center ">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  13:45 – 14:30
                </div>
                <div className="col-6 py-3">
                  ORATION I<br />
                  PROF. C. RETHINASABAPATHY ENDOWMENT ORATION
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">CHAIRPERSONS</span>
                  <br />
                  DR N VIJAYAPRABU, CHAIRMAN, TNPY AMPI
                  <br />
                  DR G BHARANIDHARAN, SECRETARY, TNPY AMPI
                  <br />
                  DR S SURESH S, HEAD - MEDICAL ONCOLOGY, APOLLO HOSPITALS,
                  VANAGARAM
                </div>
              </div>
              {/* Row 2 */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                ></div>
                <div className="col-6 py-3">
                  EVOLUTION OF RADIOTHERAPY TECHNIQUES IN THE MANAGEMENT
                  <br />
                  OF MALIGNANT DISEASE
                </div>
                <div className="col-4 py-3">
                  DR K MUTHUVELU, PROFESSOR OF RADIOLOGICAL PHYSICS, SRMMCH&RC,
                  <br />
                  KATTANGULATHUR
                </div>
              </div>
              {/* Row 3 */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  14:30 – 15:15
                </div>
                <div className="col-6 py-3">
                  PD 01: PANEL DISCUSSION
                  <br />
                  (TEAM RADIATION ONCOLOGIST AND MEDICAL PHYSICIST)
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">MODERATOR</span>
                  <br />
                  MR M MARIYAPPAN, MEDICAL PHYSICIST, APOLLO HOSPITALS,
                  TEYNAMPET
                </div>
              </div>
              {/* Row 4 */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                ></div>
                <div className="col-6 py-3">
                  STEREOTACTIC RADIOSURGERY AND RADIOTHERAPY –<br />
                  2K PRACTICES DEPLOYING TECHNICAL INNOVATIONS
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">PANELIST</span>
                  <br />
                  DR S SHAMSUDEEN, RADIATION ONCOLOGIST, APOLLO HOSPITALS,
                  TEYNAMPET
                  <br />
                  MR S ANTO VAZ, MEDICAL PHYSICIST, KOVAI MEDICAL CENTRE AND
                  HOSPITAL, COIMBATORE
                  <br />
                  DR PONNUSAMY, MEDICAL PHYSICIST , NIMHANS, BANGALORE
                  <br />
                  MR SAJI OOMMEN, MEDICALPHYSICIST, APOLLO HOSPITALS, DELHI
                  <br />
                  DR S VENDHAN, MEDICAL PHYSICIST, APOLLO HOSPITALS, TEYNAMPET
                </div>
              </div>
              {/* Row 5 */}
              <div
                className="row align-items-center m-0"
                style={{ backgroundColor: "#f3f3f3", textAlign: "center" }}
              >
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  15:15 – 15:30
                </div>
                <div className="col-8 py-3">TEA BREAK</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SCIENTIFIC SESSION I - Responsive headers for mobile */}
      <div className="d-block d-md-none">
        <div className="card border-dark rounded-0 mt-3">
          <div
            className="card-header text-center fw-bold"
            style={{ background: "#195f7d", color: "#fff", fontSize: "1rem" }}
          >
            SCIENTIFIC SESSION I
          </div>
          <div className="card-body p-0">
            <div className="px-3 py-2">
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Time
              </div>
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Session
              </div>
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Speaker / Moderator / Chairperson
              </div>
            </div>
            {[
              {
                time: "15:30 – 15:50",
                session:
                  "IT 01: FUNCTIONAL AND DOSIMETRIC INSIGHT INTO MR-LINAC",
                speaker:
                  "DR V SAI SUBRAMANIAN, CHIEF MEDICAL PHYSICIST, YASHODA HOSPITALS, HYDERABAD",
              },
              {
                time: "15:50 – 16:00",
                session:
                  "OT 01: EVALUATING THE SHAPE BASED FEATURES FOR LUNG CANCER",
                speaker: "MS M GOWRI , ANNA UNIVERSITY, CHENNAI",
              },
              {
                time: "16:00 – 16:10",
                session:
                  "OT 02: DOSIMETRIC COMPARISON OF PLANAR AND NONCOPLANAR TECHNIQUES IN STEREOTACTIC RADIOSURGERY FOR DUAL CRANIAL METASTASIS",
                speaker:
                  "MS T M HEMAVATHI , SRI RAMACHANDRA INSTITUTE OF HIGHER EDUCATION AND RESEARCH (SRIHER), CHENNAI",
              },
              {
                time: "16:10 – 17:00",
                session:
                  "PD 02: PANEL DISCUSSION\n(TEAM HAEMATOLOGIST, RADIATION ONCOLOGIST AND MEDICAL PHYSICIST)",
                speaker:
                  "MODERATOR\nDR HARISH KUMAR, RADIATION ONCOLOGIST, APOLLO HOSPITALS, VANAGARAM",
              },
              {
                time: "",
                session:
                  "ADDRESSING CHALLENGES IN MYELOABLATIVE RADIOTHERAPY:\nTMI/TMLI IN PRACTICE, SOLUTIONS AND FUTURE DIRECTIONS",
                speaker:
                  "PANELIST\nDR STEVE THOMAS, HAEMATOLOGIST, SRMC, CHENNAI\nDR B RAJESH, RADIATION ONCOLOGIST, CMC, VELLORE\nDR S SHAM, RADIATION ONCOLOGIST, APCC, CHENNAI\nDR S EBENEZER, MEDICAL PHYSICIST, CMC, VELLORE\nMR D YOGARAJ, MEDICAL PHYSICIST, APOLLO HOSPITALS, VIZAG",
              },
              {
                time: "17:00 – 18:00",
                session:
                  "QUIZ COMPETITION ON MEDICAL PHYSICS\n(STUDENTS / INTERNS / PGS)",
                speaker:
                  "QUIZ MASTERS\nDR B GOWRI, ASST PROFESSOR, GAAMCH, KANCHIPURRAM\nMS SIDONIYA VALAS, CHIEF MEDICAL PHYSICIST, DRKMH, CHENNAI\nMR GODWIN PAUL DAS, MEDICAL PHYSICIST, OGMH, CHENNAI",
              },
              {
                time: "18:00 – 18:45",
                session: "E-POSTER EVALUATION",
                speaker:
                  "DR N VIJAYAPRABU, PROFESSOR, JIPMER, PONDICHERY\nDR V HEMALATHA PRIYADARSHNI, MEDICAL PHYSICIST, RGH, CHENNAI\nDR PUTHA SUMAN KUMAR, CHIEF MEDICAL PHYSICIST, MGM, CHENNAI",
              },
              {
                time: "",
                session: "TRADE / STALL VISIT",
                speaker: "",
              },
              {
                time: "19:00 – 21:30",
                session: "GALA DINNER",
                speaker: "M WEDDINGS AND CONVENTIONS, CHENNAI",
              },
            ].map((row, idx) => (
              <div
                className="card mb-2"
                key={idx}
                style={{
                  border: "none",
                  boxShadow: "0 1px 4px rgba(25,95,125,0.06)",
                }}
              >
                <div className="card-body p-2">
                  <div
                    className="fw-bold mb-1"
                    style={{ color: "#195f7d", fontSize: "0.95rem" }}
                  >
                    {row.time}
                  </div>
                  <div
                    className="mb-1"
                    style={{
                      color: "#222",
                      fontSize: "0.95rem",
                      fontWeight: 500,
                    }}
                  >
                    {row.session}
                  </div>
                  {row.speaker && (
                    <div style={{ color: "#195f7d", fontSize: "0.92rem" }}>
                      {row.speaker}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Desktop view for SCIENTIFIC SESSION I remains unchanged */}
      <div className="row m-0 d-none d-md-flex">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              SCIENTIFIC SESSION I
              {/* You can set the session title here if needed */}
            </div>
            <div className="card-body p-0 ">
              <div className="row align-items-center m-0">
                <div
                  className="col-6 py-3 fw-bold"
                  style={{ color: "#195f7d" }}
                >
                  CHAIRPERSONS
                </div>
                <div className="col-6 py-3">
                  DR V MURALI, FORMER CHIEF MEDICAL PHYSICIST, APOLLO HOSPITALS,
                  TEYNAMPET
                  <br />
                  DR M SADIQ, RADIATION ONCOLOGIST, APOLLO HOSPITALS, TEYNAMPET
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              {/* Table Header Row */}
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  15:30 – 15:50
                </div>
                <div className="col-6 py-3">
                  IT 01: FUNCTIONAL AND DOSIMETRIC INSIGHT INTO MR-LINAC
                </div>
                <div className="col-4 py-3">
                  DR V SAI SUBRAMANIAN, CHIEF MEDICAL PHYSICIST, YASHODA
                  HOSPITALS, HYDERABAD
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  15:50 – 16:00
                </div>
                <div className="col-6 py-3">
                  OT 01: EVALUATING THE SHAPE BASED FEATURES FOR LUNG CANCER
                </div>
                <div className="col-4 py-3">
                  MS M GOWRI , ANNA UNIVERSITY, CHENNAI
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  16:00 – 16:10
                </div>
                <div className="col-6 py-3">
                  OT 02: DOSIMETRIC COMPARISON OF PLANAR AND NONCOPLANAR
                  TECHNIQUES IN STEREOTACTIC RADIOSURGERY FOR DUAL CRANIAL
                  METASTASIS
                </div>
                <div className="col-4 py-3">
                  MS T M HEMAVATHI , SRI RAMACHANDRA INSTITUTE OF HIGHER
                  EDUCATION AND RESEARCH (SRIHER), CHENNAI
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  16:10 – 17:00
                </div>
                <div className="col-6 py-3">
                  PD 02: PANEL DISCUSSION
                  <br />
                  (TEAM HAEMATOLOGIST, RADIATION ONCOLOGIST AND MEDICAL
                  PHYSICIST)
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">MODERATOR</span>
                  <br />
                  DR HARISH KUMAR, RADIATION ONCOLOGIST, APOLLO HOSPITALS,
                  VANAGARAM
                </div>
              </div>
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                ></div>
                <div className="col-6 py-3">
                  ADDRESSING CHALLENGES IN MYELOABLATIVE RADIOTHERAPY: TMI/TMLI
                  IN PRACTICE, SOLUTIONS AND FUTURE DIRECTIONS
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">PANELIST</span>
                  <br />
                  DR STEVE THOMAS, HAEMATOLOGIST, SRMC, CHENNAI
                  <br />
                  DR B RAJESH, RADIATION ONCOLOGIST, CMC, VELLORE
                  <br />
                  DR S SHAM, RADIATION ONCOLOGIST, APCC, CHENNAI
                  <br />
                  DR S EBENEZER, MEDICAL PHYSICIST, CMC, VELLORE
                  <br />
                  MR D YOGARAJ, MEDICAL PHYSICIST, APOLLO HOSPITALS, VIZAG
                </div>
              </div>
              {/* New Data Row */}

              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  17:00 – 18:00
                </div>
                <div className="col-6 py-3">
                  QUIZ COMPETITION ON MEDICAL PHYSICS
                  <br />
                  (STUDENTS / INTERNS / PGS)
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">QUIZ MASTERS</span>
                  <br />
                  DR B GOWRI, ASST PROFESSOR, GAAMCH, KANCHIPURRAM
                  <br />
                  MS SIDONIYA VALAS, CHIEF MEDICAL PHYSICIST, DRKMH, CHENNAI
                  <br />
                  MR GODWIN PAUL DAS, MEDICAL PHYSICIST, OGMH, CHENNAI
                </div>
              </div>

              {/* New Data Row */}
              <div className="row align-items-center m-0 ">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  18:00 – 18:45
                </div>
                <div className="col-6 py-3">E-POSTER EVALUATION</div>
                <div className="col-4 py-3">
                  DR N VIJAYAPRABU, PROFESSOR, JIPMER, PONDICHERY
                  <br />
                  DR V HEMALATHA PRIYADARSHNI, MEDICAL PHYSICIST, RGH, CHENNAI
                  <br />
                  DR PUTHA SUMAN KUMAR, CHIEF MEDICAL PHYSICIST, MGM, CHENNAI
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                ></div>
                <div
                  className="col-12 py-3"
                  style={{ backgroundColor: "#f3f3f3", textAlign: "center" }}
                >
                  TRADE / STALL VISIT
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  19:00 – 21:30
                </div>
                <div className="col-6 py-3">GALA DINNER</div>
                <div className="col-4 py-3">
                  M WEDDINGS AND CONVENTIONS, CHENNAI
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Day 2 Sessions - Mobile view cards (match Day 1 style) */}
      <div className="d-block d-md-none">
        <div className="card border-dark rounded-0 mt-5">
          <div
            className="card-header text-center fw-bold"
            style={{ background: "#195f7d", color: "#fff", fontSize: "1rem" }}
          >
            27.09.2025 - DAY 2 (SATURDAY)
          </div>
          <div className="card-body p-0">
            <div className="px-3 py-2">
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Time
              </div>
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Session
              </div>
              <div
                className="fw-bold"
                style={{ color: "#195f7d", fontSize: "0.98rem" }}
              >
                Speaker / Moderator / Chairperson
              </div>
            </div>
            {[
              {
                time: "06:30 – 07:30",
                session:
                  "WELLNESS SESSION (COLLABORATION WITH HEARTFULNESS INSTITUTE, CHENNAI)",
                speaker:
                  "MS S SARASWATHI CHITRA, CHIEF MEDICAL PHYSICIST AND RSO, APOLLO HOSPITALS, TEYNAMPET",
              },
              {
                time: "07:30 – 08:00",
                session: "BREAK",
                speaker: "",
              },
              {
                time: "08:00 – 08:40",
                session:
                  "PHYSICAL AND BIOLOGICAL METRICS IN TREATMENT PLAN EVALUATION",
                speaker:
                  "DR T GANESH, FORMER CHIEF MEDICAL PHYSICIST, MANIPAL HOSPITALS, DELHI",
              },
              {
                time: "08:40 – 09:00",
                session:
                  "IT 02: AUTOMATION IN CONTOURING, TREATMENT PLANNING AND QUALITY ASSURANCE",
                speaker:
                  "DR B PAUL RAVINDRAN, PRINCIPAL, NERMPI,CIHSR, NAGALAND",
              },
              {
                time: "09:00 – 09:45",
                session:
                  "ORATION II\nPROF. CYRIL A. JAYACHANDRAN ENDOWMENT ORATION",
                speaker:
                  "CHAIRPERSONS\nDR N VIJAYAPRABU, CHAIRMAN, TNPY AMPI\nDR G BHARANIDHARAN, SECRETARY, TNPY AMPI\nDR DAYANANDA SHARMA, HEAD - MEDICAL PHYSICS, APCC, CHENNAI",
              },
              {
                time: "09:45 – 10:45",
                session: "INAUGURATION CEREMONY & ADDRESS BY DIGNITARIES",
                speaker: "",
              },
              {
                time: "10:45 – 11:00",
                session: "TEA BREAK",
                speaker: "",
              },
              {
                time: "11:00 – 11:40",
                session: "ORATION III\nAROI ORATION",
                speaker:
                  "CHAIRPERSONS\nDR N VIJAYAPRABU, CHAIRMAN, TNPY AMPI\nDR G BHARANIDHARAN, SECRETARY, TNPY AMPI\nDISTINGUISHED GUEST\nDR A V LAKSHMANAN, FORMER DIRECTOR (ADMIN), CIA, ADAYAR, CHENNAI",
              },
              {
                time: "",
                session:
                  "THE EVOLUTION OF MEDICAL PHYSICS: AN ONCOLOGIST’S PERSPECTIVE",
                speaker:
                  "DR ALEXANDER JOHN, PROFESSOR OF RADIATION ONCOLOGY, CIA, ADAYAR, CHENNAI",
              },
            ].map((row, idx) => (
              <div
                className="card mb-2"
                key={idx}
                style={{
                  border: "none",
                  boxShadow: "0 1px 4px rgba(25,95,125,0.06)",
                }}
              >
                <div className="card-body p-2">
                  <div
                    className="fw-bold mb-1"
                    style={{ color: "#195f7d", fontSize: "0.95rem" }}
                  >
                    {row.time}
                  </div>
                  <div
                    className="mb-1"
                    style={{
                      color: "#222",
                      fontSize: "0.95rem",
                      fontWeight: 500,
                    }}
                  >
                    {row.session}
                  </div>
                  {row.speaker && (
                    <div style={{ color: "#195f7d", fontSize: "0.92rem" }}>
                      {row.speaker}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Desktop view for Day 2 - hidden on mobile */}
      <div className="row m-0 d-none d-md-flex mt-5">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 ">
            <div className="col-12 p-0">
              <div className="card border-dark rounded-0">
                <div
                  className="card-body text-center"
                  style={{ background: "#e9f5fa", color: "#195f7d" }}
                >
                  <h4 className="fw-bold mb-0">26.09.2025 - DAY 2 (FRIDAY)</h4>
                </div>
              </div>
              <div
                className="card-header text-center fw-bold"
                style={{
                  background: "#195f7d",
                  color: "#fff",
                  fontSize: "1.15rem",
                }}
              >
                DAY 2 SESSIONS
              </div>
            </div>
            <div className="card-body p-0">
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  06:30 – 07:30
                </div>
                <div className="col-6 py-3">
                  WELLNESS SESSION
                  <br />
                  (COLLABORATION WITH HEARTFULNESS INSTITUTE, CHENNAI)
                </div>
                <div className="col-4 py-3">
                  MS S SARASWATHI CHITRA, CHIEF MEDICAL PHYSICIST AND RSO,
                  APOLLO HOSPITALS, TEYNAMPET
                </div>
              </div>
              {/* New Data Row */}
              <div
                className="row align-items-center m-0"
                style={{ backgroundColor: "#f3f3f3", textAlign: "center" }}
              >
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  07:30 – 08:00
                </div>
                <div className="col-8 py-3">BREAK</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              CME - ACADEMIC SESSION
            </div>
            <div className="card-body p-0">
              <div className="row align-items-center m-0">
                <div
                  className="col-6 py-3 fw-bold"
                  style={{ color: "#195f7d" }}
                >
                  CHAIRPERSONS
                </div>
                <div className="col-6 py-3">
                  DR R M NEHRU, FORMER SCIENTIST, OFFICER IN
                  CHARGE,SRRC,AERB,CHENNAI
                  <br />
                  DR P TAMIL KUMAR, CHIEF MEDICAL PHYSICIST, DR.RAI MEDICAL
                  CENTER, CHENNAI
                </div>
              </div>
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  08:00 – 08:40
                </div>
                <div className="col-6 py-3">
                  PHYSICAL AND BIOLOGICAL METRICS IN TREATMENT PLAN EVALUATION
                </div>
                <div className="col-4 py-3">
                  DR T GANESH, FORMER CHIEF MEDICAL PHYSICIST, MANIPAL
                  HOSPITALS, DELHI
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              SCIENTIFIC SESSION II
            </div>
            <div className="card-body p-0">
              <div className="row align-items-center m-0">
                <div
                  className="col-6 py-3 fw-bold"
                  style={{ color: "#195f7d" }}
                >
                  CHAIRPERSONS
                </div>
                <div className="col-6 py-3">
                  DR SIMON PAVAMANI, SR. PROFESSOR OF RADIATION ONCOLOGY, CMC,
                  VELLORE
                  <br />
                  DR N SURENDARAN, PROFESSOR OF RADIOLOGICAL PHYSICS, SIMS,
                  CHENNAI
                </div>
              </div>
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  08:40 – 09:00
                </div>
                <div className="col-6 py-3">
                  IT 02: AUTOMATION IN CONTOURING, TREATMENT PLANNING AND
                  QUALITY ASSURANCE
                </div>
                <div className="col-4 py-3">
                  DR B PAUL RAVINDRAN, PRINCIPAL, NERMPI,CIHSR, NAGALAND
                </div>
              </div>
              {/* New Row for ORATION II */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  09:00 – 09:45
                </div>
                <div className="col-6 py-3">
                  ORATION II
                  <br />
                  PROF. CYRIL A. JAYACHANDRAN ENDOWMENT ORATION
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">CHAIRPERSONS</span>
                  <br />
                  DR N VIJAYAPRABU, CHAIRMAN, TNPY AMPI
                  <br />
                  DR G BHARANIDHARAN, SECRETARY, TNPY AMPI
                  <br />
                  DR DAYANANDA SHARMA, HEAD - MEDICAL PHYSICS, APCC, CHENNAI
                </div>
              </div>
              {/* New Row for ORATION II */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                ></div>
                <div className="col-6 py-3">
                  SHAPING THE FUTURE OF MEDICAL PHYSICS THROUGH TRANSLATIONAL
                  RESEARCH, CAPACITY BUILDING AND PERSONALIZED PATIENT CARE
                </div>
                <div className="col-4 py-3">
                  DR V SUBRAMANI, ASSO. PROFESSOR, AIIMS, NEW DELHI
                </div>
              </div>
              {/* New Row for Translational Research Session */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  09:45 – 10:45
                </div>
                <div
                  className="col-8 py-4"
                  style={{
                    color: "#1b5f7d",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  INAUGURATION CEREMONY & ADDRESS BY DIGNITARIES
                </div>
              </div>
              {/* New Row for Tea Break */}
              <div
                className="row align-items-center m-0 border-bottom m-0"
                style={{ backgroundColor: "#f3f3f3", textAlign: "center" }}
              >
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  10:45 – 11:00
                </div>
                <div className="col-8 py-3">TEA BREAK</div>
                <div className="col-1 py-3"></div>
              </div>
              {/* New Row for ORATION III */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  11:00 – 11:40
                </div>
                <div className="col-6 py-3">
                  ORATION III
                  <br />
                  AROI ORATION
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">CHAIRPERSONS</span>
                  <br />
                  DR N VIJAYAPRABU, CHAIRMAN, TNPY AMPI
                  <br />
                  DR G BHARANIDHARAN, SECRETARY, TNPY AMPI
                  <br />
                  <span className="fw-semibold">DISTINGUISHED GUEST</span>
                  <br />
                  DR A V LAKSHMANAN, FORMER DIRECTOR (ADMIN), CIA, ADAYAR,
                  CHENNAI
                </div>
              </div>
              {/* New Row for Oncologist's Perspective */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                ></div>
                <div className="col-6 py-3">
                  THE EVOLUTION OF MEDICAL PHYSICS: AN ONCOLOGIST’S PERSPECTIVE
                </div>
                <div className="col-4 py-3">
                  DR ALEXANDER JOHN, PROFESSOR OF RADIATION ONCOLOGY, CIA,
                  ADAYAR, CHENNAI
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              SCIENTIFIC SESSION III
            </div>
            <div className="card-body p-0">
              <div className="row align-items-center m-0">
                <div
                  className="col-6 py-3 fw-bold"
                  style={{ color: "#195f7d" }}
                >
                  CHAIRPERSONS
                </div>
                <div className="col-6 py-3">
                  DR P KALIYAPPAN, PROFESSOR OF RADIOLOGICAL PHYSICS, BALAJI
                  HOSPITAL AND MEDICAL COLLEGE, CHENNAI
                  <br />
                  DR S PANEERSELVAM, ADJUNCT FACULTY, SRMC, CHENNAI
                </div>
              </div>
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  11:40 – 12:00
                </div>
                <div className="col-6 py-3">
                  IT 03: PET-CT IN ONCOLOGY: REGULATORY REQUIREMENTS
                </div>
                <div className="col-4 py-3">
                  DR M SENTHIL KUMAR, SCIENTIFIC OFFICER, AERB, CHENNAI
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  12:00 – 12:10
                </div>
                <div className="col-6 py-3">
                  OT 03: INTEGRATING PRINCIPAL COMPONENT ANALYSIS WITH RF, KNN,
                  AND SVM FOR CT IMAGE ANALYSIS
                </div>
                <div className="col-4 py-3">
                  MS K SAITHANI BEGUM, BHARATHIAR UNIVERSITY, COIMBATORE
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  12:10 – 12:20
                </div>
                <div className="col-6 py-3">
                  OT 04: PERFORMANCE ASSESSMENT AND SOFTWARE INTEGRATION OF AN
                  IN-HOUSE OPTICAL COMPUTED TOMOGRAPHY SCANNER FOR
                  THREE-DIMENSIONAL GEL DOSIMETRY
                </div>
                <div className="col-4 py-3">
                  MR S K NASIM ALI, CHRISTIAN MEDICAL COLLEGE, VELLORE
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              TRADE SESSION
            </div>
            <div className="card-body p-0">
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              <div className="row align-items-center m-0">
                {" "}
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  {" "}
                  12:20 – 13:00{" "}
                </div>{" "}
                <div className="col-6 py-3">
                  {" "}
                  TT01: ADAPTIVE RADIOTHERAPY AND ADVANCED RADIATION DOSIMETRY{" "}
                </div>{" "}
                <div className="col-4 py-3">
                  {" "}
                  <span className="fw-semibold">CHAIRPERSONS</span> <br /> DR E
                  VARATHARAJAN, CHIEF MEDICAL PHYSICIST, BILLROTH, CHENNAI{" "}
                  <br /> DR S MAHENDRA MOHAN, CHIEF MEDICAL PHYSICIST, MERIDIAN
                  HOSPITAL, CHENNAI <br /> DR S SENTHIL KUMAR, PROFESSOR OF
                  RADIOLOGICAL PHYSICS, MMC, MADURAI{" "}
                </div>{" "}
              </div>{" "}
              {/* New Data Row */}{" "}
              <div className="row align-items-center m-0">
                {" "}
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                ></div>{" "}
                <div className="col-6 py-3"></div>{" "}
                <div className="col-4 py-3">
                  {" "}
                  <span className="fw-semibold">
                    TRADE REPRESENTATIVES
                  </span>{" "}
                  <br /> VARIAN (SIEMENS) <br /> ELEKTA <br /> ACCURAY <br />{" "}
                  PTW{" "}
                </div>{" "}
              </div>{" "}
              {/* New Data Row */}{" "}
              <div
                className="row align-items-center m-0"
                style={{ backgroundColor: "#f3f3f3", textAlign: "center" }}
              >
                {" "}
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  {" "}
                  13:00 – 13:40{" "}
                </div>{" "}
                <div className="col-8 py-3">LUNCH BREAK</div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              SCIENTIFIC SESSION IV
            </div>
            <div className="card-body p-0">
              <div className="row align-items-center m-0">
                <div
                  className="col-6 py-3 fw-bold"
                  style={{ color: "#195f7d" }}
                >
                  CHAIRPERSONS
                </div>
                <div className="col-6 py-3">
                  DR S D SHARMA, HEAD MEDICAL PHYSICS, BARC, MUMBAI
                  <br />
                  DR TIMOTHY PEACE, ASSO. PROFESSOR OF RADIOLOGICAL PHYSICS,
                  CMC, VELLORE
                </div>
              </div>
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  13:40 – 14:00
                </div>
                <div className="col-6 py-3">
                  IT 04: PROTON VS CARBON ION: PHYSICS AND RADIOBIOLOGY
                </div>
                <div className="col-4 py-3">
                  DR GANAPATHY KRISHNAN, LEAD MEDICAL PHYSICIST, APCC, CHENNAI
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  14:00 – 14:10
                </div>
                <div className="col-6 py-3">
                  OT 05: DIGITAL TRANSFORMATION OF QUALITY ASSURANCE IN MEDICAL
                  PHYSICS: DESIGN AND IMPLEMENTATION OF A WEB-BASED QA
                  MANAGEMENT SYSTEM
                </div>
                <div className="col-4 py-3">
                  MS P JENIFER SNEHA, CHRISTIAN MEDICAL COLLEGE, VELLORE
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  14:10 – 14:20
                </div>
                <div className="col-6 py-3">
                  OT 06: ASSESSMENT OF AUTOMATIC SEGMENTATION OF DIR SOFTWARE:
                  ECLIPSE AND VELOCITY USING ANTHROPOMORPHIC HEAD PHANTOM
                </div>
                <div className="col-4 py-3">
                  MS S SUSHMA EVANGELIN, KALYAN SINGH SUPER SPECIALITY CANCER
                  INSTITUTE, LUCKNOW
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              SCIENTIFIC SESSION V
            </div>
            <div className="card-body p-0">
              <div className="row align-items-center m-0">
                <div
                  className="col-6 py-3 fw-bold"
                  style={{ color: "#195f7d" }}
                >
                  CHAIRPERSONS
                </div>
                <div className="col-6 py-3">
                  DR J VIJAYALAKSHMI, PROFESSOR OF RADIOLOGICAL PHYSICS, SMC,
                  CHENNAI
                  <br />
                  DR A KOPPERUNTHDEVI, PROFESSOR RADIOLOGICAL PHYSICS, MMC,
                  CHENNAI
                </div>
              </div>
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  14:20 – 14:40
                </div>
                <div className="col-6 py-3">
                  IT 05: BRACHYTHERAPY: A DYING ART OR A REINVENTING MODALITY?
                </div>
                <div className="col-4 py-3">
                  DR K SARAVANAN, ASST PROFESSOR OF RADIOLOGICAL PHYSICS,
                  JIPMER, PUDHUCHERRY
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  14:40 – 14:50
                </div>
                <div className="col-6 py-3">
                  OT 07: COMMISSIONING AND DOSIMETRIC EVALUATION OF AN
                  INDIGENOUSLY DEVELOPED INTRACAVITARY-INTERSTITIAL INTRAVAGINAL
                  TEMPLATE FOR IMAGE-GUIDED HDR BRACHYTHERAPY IN CERVICAL
                  CANCER: A COMPARATIVE STUDY WITH PERINEAL INTERSTITIAL
                  APPLICATORS
                </div>
                <div className="col-4 py-3">
                  DR VENKATESAN KALIYAPERUMAL, SCIENTIST D, DRDO, DELHI
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  14:50 – 15:00
                </div>
                <div className="col-6 py-3">
                  OT 08: FABRICATION OF PHANTOM FOR MRI COMPATIBLE BRACHYTHERAPY
                  APPLICATOR COMMISSIONING
                </div>
                <div className="col-4 py-3">
                  MS P S JANANI, BHARATHIAR UNIVERSITY, COIMBATORE
                </div>
              </div>
              {/* New Data Row */}
              <div
                className="row align-items-center m-0 border-bottom m-0"
                style={{ backgroundColor: "#f3f3f3", textAlign: "center" }}
              >
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  15:00 – 15:15
                </div>
                <div
                  className="col-8 py-3"
                  style={{ textAlign: "center", backgroundColor: "#f3f3f3" }}
                >
                  TEA BREAK
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              SCIENTIFIC SESSION VI
            </div>
            <div className="card-body p-0">
              <div className="row align-items-center m-0">
                <div
                  className="col-6 py-3 fw-bold"
                  style={{ color: "#195f7d" }}
                >
                  CHAIRPERSONS
                </div>
                <div className="col-6 py-3">
                  DR T GANESH, FORMER CHIEF MEDICAL PHYSICIST, MANIPAL
                  HOSPITALS, DELHI
                  <br />
                  DR MOHAN RAMACHANDRAN, SENIOR MEDICAL PHYSICIST, UAE
                </div>
              </div>
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  SPEAKER / MODERATOR / CHAIRPERSON
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  15:15 – 15:25
                </div>
                <div className="col-6 py-3">
                  OT 09: DEVELOPMENT OF INNOVATIVE FLEXIBLE, PRINTABLE,
                  NONMETALLIC RADIO-OPAQUE MARKERS FOR RADIOTHERAPY AND
                  IMAGE-GUIDED INTERVENTIONS
                </div>
                <div className="col-4 py-3">
                  DR S SENTHILKUMAR, MADURAI MEDICAL COLLEGE, MADURAI
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  15:25 – 15:35
                </div>
                <div className="col-6 py-3">
                  OT 10: EVALUATION OF TIME-AVERAGED DOSE RATE (TADR) FOR
                  ROBOTIC RADIOSURGERY LINEAR ACCELERATOR USING REGULATORY
                  GUIDELINES
                </div>
                <div className="col-4 py-3">
                  MS KEERTHANA SUDANDRA BABU, APOLLO CANCER CENTRE, TEYNAMPET
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0 border-bottom m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  15:35 – 15:45
                </div>
                <div className="col-6 py-3">
                  OT 11: EVALUATION AND COMPARISON OF FLEXI IRIDIUM AND FLEXI
                  COBALT BRACHYTHERAPY SOURCES IN WATER AND IN DIFFERENT TISSUE
                  PHANTOMS USING ELECTRON GAMMA SHOWER MONTE CARLO SIMULATION
                </div>
                <div className="col-4 py-3">
                  MR A S JIM ELLIOT, CHRISTIAN MEDICAL COLLEGE, VELLORE
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  15:45 – 16:30
                </div>
                <div className="col-6 py-3">PD 03: PANEL DISCUSSION</div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">MODERATOR</span>
                  <br></br>
                  DR K THAYALAN, RTD PROFESSOR OF RADIOLOGICAL PHYSICS
                </div>
              </div>
              {/* New Data Row */}
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                ></div>
                <div className="col-6 py-3">
                  THE FUTURE OF MEDICAL PHYSICS EDUCATION AND TRAINING:
                  PREPARING FOR THE AI-DRIVEN ERA
                </div>
                <div className="col-4 py-3">
                  <span className="fw-semibold">PANELIST</span>
                  <br></br>
                  DR P ARUNA, RTD. PROFESSOR, ANNA UNIVERSITY, CHENNAI<br></br>
                  DR S D SHARMA, HEAD MEDICAL PHYSICS, BARC, MUMBAI<br></br>
                  DR M RAVIKUMAR, DIRECTOR OF MEDICAL PHYSICS, SSCHRC, BANGALORE
                  <br></br>
                  DR C S SUREKA, ASSO. PROFESSOR, BHARATHIAR UNIVERSITY,
                  COIMBATORE<br></br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* VALEDICTORY FUNCTION - Desktop card */}
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              VALEDICTORY FUNCTION
            </div>
            <div className="card-body p-0">
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-10 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                {/* <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                ></div> */}
              </div>
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  16:30 – 17:30
                </div>
                <div
                  className="col-10 py-3"
                  style={{
                    fontSize: "1.1rem",
                    color: "#195f7d",
                    fontWeight: 500,
                  }}
                >
                  AWARDS (DETAILED IN CONFERENCE WEBSITE)
                  <br />
                  CERTIFICATE DISTRIBUTION
                  <br />
                  VOTE OF THANKS
                </div>
                {/* <div className="col-4"></div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* TNPY AMPI ANNUAL GENERAL BODY MEETING 2025 - Desktop card */}
      <div className="row m-0 mb-3">
        <div className="col-12 p-0">
          <div className="card border-dark rounded-0 mt-3">
            <div
              className="card-header text-center fw-bold"
              style={{
                background: "#195f7d",
                color: "#fff",
                fontSize: "1.15rem",
              }}
            >
              ANNUAL GENERAL BODY MEETING
            </div>
            <div className="card-body p-0">
              <div
                className="row align-items-center border-bottom m-0"
                style={{ background: "#e9f5fa" }}
              >
                <div
                  className="col-2 text-center fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Time
                </div>
                <div
                  className="col-6 fw-bold py-2"
                  style={{ color: "#195f7d", borderRight: "1px solid #195f7d" }}
                >
                  Session
                </div>
                <div
                  className="col-4 fw-bold py-2"
                  style={{ color: "#195f7d" }}
                >
                  Participants
                </div>
              </div>
              <div className="row align-items-center m-0">
                <div
                  className="col-2 text-center fw-bold py-3"
                  style={{ color: "#195f7d" }}
                >
                  17:30 – 18:30
                </div>
                <div
                  className="col-6 py-3"
                  style={{
                    fontSize: "1.1rem",
                    color: "#195f7d",
                    fontWeight: 500,
                  }}
                >
                  TNPY AMPI ANNUAL GENERAL BODY MEETING 2025
                </div>
                <div
                  className="col-4"
                  style={{
                    fontSize: "1rem",
                    color: "#195f7d",
                    marginTop: "8px",
                  }}
                >
                  <span className="fw-bold"></span> TNPY AMPI MEMBERS
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TspConferenceProgram;
